const defaultRender = (value) => (value ? value : "--");

const clientListColumns = [
  {
    title: "Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Mobile No",
    dataIndex: "mobile_no",
    render: defaultRender,
  },
  {
    title: "Role",
    dataIndex: "role",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
];

export default clientListColumns;
